export default __webpack_public_path__ + "static/media/conditions.ab396b2f.png";